<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header py-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">Lista urlopów</h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="success"
          class="text-nowrap"
          @click.prevent="$router.push('/urlopy/nowy')">
          <i class="material-icons">add</i>
          Dodaj urlop
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">Rozpoczęcie</th>
            <th
              scope="col"
              class="border-0">Zakończenie</th>
            <th
              scope="col"
              class="border-0">Ostatnie możliwe zamówienie:</th>
            <th
              scope="col"
              class="border-0">Najbliższa dostawa</th>
            <th
              scope="col"
              class="border-0">Rozpoczęcie wyświetlania</th>
            <th
              scope="col"
              class="border-0">Zakończenie wyświetlania</th>
            <th
              scope="col"
              class="border-0">Akcje</th>
          </tr>
        </thead>
        <tbody v-if="loaded && vacations">
          <tr
            v-for="(vacation, index) of vacations"
            :key="'user-' + index">
            <td class="align-middle">
              {{ vacation.start_at }}
            </td>
            <td class="align-middle">
              {{ vacation.end_at }}
            </td>
            <td class="align-middle">
              {{ vacation.last_possible_order_at }}
            </td>
            <td class="align-middle">
              {{ vacation.closest_possible_order_at }}
            </td>
            <td class="align-middle">
              {{ vacation.start_showing_at }}
            </td>
            <td class="align-middle">
              {{ vacation.end_showing_at }}
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/urlopy/edycja/' + vacation.id)"
                class="mr-2 action-button"
                title="Edytuj">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                class="action-button"
                theme="danger"
                @click.native="removeVacation(vacation.id)"
                title="Usuń">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="vacations.length === 0">
            <td
              colspan="7"
              class="text-center">
              Brak urlopów do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded || !vacations"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="load_error"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage"/>

  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../utils/FormUtils.js';
import HasFilters from './../mixins/HasFilters.vue';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'vacations',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  data () {
    return {
      vacations: [],
      loaded: false,
      load_error: false,
      removeInProgress: false,
      filters: {
        search: '',
      }
    };
  },
  mounted () {
    this.loadFilteredData();
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = {
        search: this.filters.search
      };
      ListUtils.loadItemsData(this, {
        endpoint: '/vacations/items?page=' + this.currentPage,
        listField: 'vacations',
        errorKey: 'load_error',
        pagination: true,
        params: {
          where,
        }
      });
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['vacations-filters-form'], this.debouncedLoadFilteredData);
    },
    removeVacation (vacationsID) {
      this.removeInProgress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/vacations/delete/',
        id: vacationsID,
        successTitle: 'Usunięto urlop',
        successText: 'Wybrany urlop został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten urlop?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie urlopu nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>

